import api from "app/api/requests/Gallery";
import getChatToken from "app/api/getChatToken";
import { Resource } from 'app/api/types';

export const ADD_RESOURCE = 'ADD_RESOURCE';
export const SET_PROGRESS = 'SET_PROGRESS';

export const putResource = (payload: { albumId: string, resource: Resource, file?: File, preview?: File }) => (dispatch: any): any => {
	const token = getChatToken();
	return api.putResource(token, payload.albumId, payload.resource, (progress) => dispatch({
		type: SET_PROGRESS,
		payload: progress
	}), payload.file, payload.preview)
		.then(response => {
			dispatch({
				type: ADD_RESOURCE, payload: { resource: response, albumId: payload.albumId }
			});
		});
};
